import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";
import axios from "axios";
import { API_BASE_URL } from "../utils/constants";
import { openNotification } from "../utils/helpers";
import moment from "moment";
import { useSelector } from "react-redux";
import Connectivity from "../Components/ShowConnectivity";
import { Form, Button,  Radio, Space } from "antd";
import { useParams, useHistory } from "react-router-dom";
import AppFooter from "../Components/Footer";
import http from "../api/client";

function Settings() {
  const params = useParams();
  const companyId = params.companyId;
  let history = useHistory();
  const navbarVisibility = useSelector((state) => state.isNavbarVisibleReducer);
  // console.log("Navbar Variable from Redux in SETTINGS", navbarVisibility);

  const [responseText, setResponseText] = useState();
  const [form] = Form.useForm();
  const [accountSettings, setAccountSettings] = useState();
  const [company, setCompany] = useState({});
  const [syncTypeValue, setSyncTypeValue] = useState();

  useEffect(() => {
    apiCallToGetAccountsSettings();
  }, []);

  useEffect(() => {
    getCompanyDetails();
  }, []);

  const getCompanyDetails = () => {
    http
      .get("/api/company/details?companyId=" + params.companyId)
      .then(async (res) => {
        const company = await res.data;
        // console.log("Comapny Data", company);
        setCompany(company.data);
      })
      .catch((err) => {
        console.log("err in catch of getCompanyDetails", err);
        if(err.response?.status === 401 ){
          HandleUnauthorizedUserFlow(err);
          }

          //network error 
          if(err.message){
            openNotification(
              "topRight",
              "Unauthorized!",
              err.message,
              "error"
            );   
            return history.push('/unAuthorizedPage');
          } 
      });
  }; 

  function HandleUnauthorizedUserFlow(err){
    openNotification(
      "topRight",
      "Unauthorized!",
      err.response.data.message,
      "error"
    );         
   
  return history.push("/unAuthorizedUser");
}

  function apiCallToGetAccountsSettings() {
    http
      .get("/api/qbo/accountSettings?companyId=" + companyId)
      .then((res) => {
        const compSettings = res.data;
        // setData(res.data);
        // setCogs(res.data.cogs);
        console.log("compSettings synctype", res.data.companySettings.sync_type);
        setAccountSettings(res.data);
        setSyncTypeValue(res.data.companySettings.sync_type);
      })
      .catch((err) => {
        console.log("err in catch of accounts Settings", err);
      });
  }

  const onChange = (e) => {
    console.log("radio checked", e.target.value);

    setSyncTypeValue(e.target.value);
  };

  const onFinish = (values) => {
    values.inventoryStartDate = moment.utc(values.inventoryStartDate).local();
    values.comp_id = params.companyId;
    values.syncType = syncTypeValue;
    console.log("Form Data", values);
    http
      .post( "/api/qbo/saveAccountSettings", values)
      .then((res) => {
        setResponseText(res.data.message);
        console.log("res", res);
        openNotification('topRight', 'Success!', res.data.message);
      })
      .catch((err) => {
        console.log("err in save of setting page", err);
        if(err.response ){
          if(err.response.status === 401 ){
            // console.log("unauthorized in welcome: ",err.response.data.message);
            openNotification(
              "topRight",
              "Unauthorized!",
              err.response.data.message,
              "error"
            );
            history.push("/unAuthorizedUser");
          }
        }
      });
  };

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 16,
      },
      sm: {
        span: 16,
      },
    },
  };

  return (
    <div className=" bg-white h-screen flex flex-col">
      <div className="px-16 flex-1">
      {accountSettings && (
        <Form
          {...formItemLayout}
          form={form}
          name="register"
          onFinish={onFinish}
          initialValues={{
            inventoryStartDate: accountSettings.companySettings
              .item_starting_date
              ? moment(accountSettings.companySettings.item_starting_date)
              : null,
          }}
          scrollToFirstError
        >
          {/* {company && <Connectivity company={company} />} */}

         
          <div className="w-full  border bg-white mt-24">
            <div className="w-full grid grid-cols-12 ">
              <div className="pt-2 col-span-12 flex px-2 ">
                <div className=" col-span-10 text-lg flex justify-start px-12">
                  <p>
                    The{" "}
                    <span className="font-bold">
                      Integration Starting Date{" "}
                    </span>
                    used to sync data from Shopify to QuickBooks.
                  </p>
                </div>

                <div className=" col-span-12 grid grid-cols-12 border-dotted border-t-2 h-1"></div>
              </div>

              {/* Conditional ui view for Inventoried Items  */}

              <div className="col-span-12 px-12">
                <div className="  pb-2">
                  <Radio.Group onChange={onChange} value={syncTypeValue}>
                    <Space direction="vertical">
                      <Radio value={"manualSync"}>
                        <h1>Manual Sync</h1>
                        <p className="-mt-2">
                          Select this option if you want to manually sync your
                          shopify data to QuickBooks Online account.{" "}
                        </p>
                        <p className="-mt-4">
                          This option is designed for businesses who want more
                          control over syncing.
                        </p>

                        {syncTypeValue === "manualSync" && (
                          <div className=" col-span-12 flex gap-10 ">
                            
                            <p className="text-md">
                              <span className="text-red-600 text-2xl">*</span>
                              Integrations Starting Date:
                            </p>
                           
                            <Form.Item
                              name="inventoryStartDate"
                              
                            >
                             
                              <DatePicker
                              
                                className="content-start"
                                style={{
                                  width: 150,
                                }}
                               
                                placeholder="Inventory Start Date"
                                disabledDate={(current) => {
                                  let customDate = moment()
                                    .subtract(60, "days")
                                    .format("YYYY-MM-DD");
                                  return (
                                    current < moment(customDate, "YYYY-MM-DD")
                                  );
                                }}
                              />
                            </Form.Item>
                           
                          </div>
                        )}
                      </Radio>

                      <Radio value={"liveSync"}>
                        <h1>Live Sync</h1>
                        <p className="-mt-2">
                          Select this option if you want to Live sync your
                          shopify data to QuickBooks Online account.{" "}
                        </p>
                        <p className="-mt-4">
                          This option is designed for businesses who want more
                          control over syncing.
                        </p>
                      </Radio>
                      <Radio value={"both"}>
                        <h1>Both</h1>
                        <p className="-mt-2">Select this option if you want to handle both manual and live sync.</p>

                        {syncTypeValue === "both" && (
                          <div className=" col-span-12 flex gap-10">
                            
                            <p className="text-md">
                              <span className="text-red-600 text-2xl">*</span>
                              Integrations Starting Date:
                            </p>
                            
                            <Form.Item
                              name="inventoryStartDate"
                             
                            >
                             
                              <DatePicker
                                
                                className=""
                                style={{
                                  width: 150,
                                }}
                                
                                placeholder="Inventory Start Date"
                                disabledDate={(current) => {
                                  let customDate = moment()
                                    .subtract(60, "days")
                                    .format("YYYY-MM-DD");
                                  return (
                                    current < moment(customDate, "YYYY-MM-DD")
                                  );
                                }}
                              />
                            </Form.Item>
                            
                          </div>
                        )}
                      </Radio>
                    </Space>
                  </Radio.Group>
                </div>
              </div>
            </div>
          </div>

          {/* Buttons save and cancel */}

          <div className=" col-span-12 grid grid-cols-12 mt-4">
            <div className="py-2 col-span-6  flex justify-start gap-4">
              <Button
              
                className="  w-24"
                type="primary"
                htmlType="submit"
              >
                Save
              </Button>

              <Button
                loading={false}
                className="  w-24"
                onClick={(e) => {
                  alert("Cancel Botton Clicked!");
                }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Form>
      )}
      </div>
      
      <div className="flex-none">
        <AppFooter/>
      </div>

   
    </div>
  );
}

export default Settings;
